import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import R from 'ramda';
import Heading from '@cotyorg/ccx-atoms/Heading';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import { HeroFullOverlay } from '@cotyorg/ccx-organism-hero';
import StandardLayout from '../../templates/StandardLayout';

const AnimalTestingComponent = ({ heading, bodyCopy }) => (
  <StandardLayout>
    <div className="grid-container">
      <div className="grid-x grid-margin-x">
        <div className="cell">
          <div className="hero-absolute-image">
            <HeroFullOverlay heroStoreDataKey="mainHero" />
          </div>
        </div>

        <div className="cell xsmall-14 xsmall-offset-1 large-9">
          <Heading level={2} extraClass="animal-testing-heading">
            {heading}
          </Heading>

          <Paragraph>{bodyCopy}</Paragraph>
        </div>
      </div>
    </div>
  </StandardLayout>
);

AnimalTestingComponent.propTypes = {
  heading: PropTypes.string,
  bodyCopy: PropTypes.string,
};

export default connect(({ content }) => ({
  heading: R.prop('heading', content),
  bodyCopy: R.prop('bodyCopy', content),
}))(AnimalTestingComponent);
